import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Select, message } from 'antd'
import './../../ui.style.scss'

class UsersEmailInput extends React.Component {
  constructor (props) {
    super(props)
    const { value } = this.props
    this.state = {
      selectedItems: props.selectedItems && props.selectedItems.length ? props.selectedItems : [],
      autoFocus: false,
      searchVal: '',
      metaOptions: value || []
    }
  }
    onSearch = (value) => {
      this.lastSearchedValue = value
      this.setState({ searchVal: value })
    }

    isValidEmails = (emails) => {
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      const allValid = emails.every((email) => {
        const isValid = regex.test(email)
        console.log('email:', email, 'isValid:', isValid)
        return isValid
      })
      return allValid
    };

    onChangeTag = (value) => {
      if (this.isValidEmails(value)) {
        this.setState({ metaOptions: value, searchVal: '' })
        this.props.handleChange(value)
      } else message.warn('Please enter a valid Email')
    }

    componentWillReceiveProps (nextProps) {
      if (!_.isEqual(nextProps.type, this.props.type)) {
        this.setState({ metaOptions: [] })
      }
    }

    render () {
      const {
        placeholder,
        parentCompoent,
        className,
        containerClass,
        disabled,
        mode
      } = this.props
      const { selectedItems, searchVal, metaOptions } = this.state
      const isNotPresent = _.isEmpty((metaOptions || []).find(tag => tag === searchVal))

      return (
        <Select
          key={JSON.stringify(selectedItems)}
          className={`input-tags user-ip-input  ${containerClass}`}
          mode={isNotPresent ? mode : 'multiple'}
          dropdownClassName={`${className || ''}${(searchVal && isNotPresent) ? ' hide-manual-tag-first' : ''}`}
          value={metaOptions || undefined}
          placeholder={placeholder}
          onSearch={this.onSearch}
          onChange={this.onChangeTag}
          getPopupContainer={() => document.getElementById(parentCompoent)}
          filterOption={false}
          disabled={disabled}
        />
      )
    }
}

UsersEmailInput.propTypes = {
  /** Placeholder text of TagsInput. */
  placeholder: PropTypes.string
}

UsersEmailInput.defaultProps = {
  selectedItems: [],
  placeholder: 'Select',
  parentCompoent: 'root',
  mode: 'tags'
}

export default UsersEmailInput
